/* global axios */
import ApiClient from '../ApiClient';

class PilotFaqs extends ApiClient {
  constructor() {
    super('pilot/faqs', { accountScoped: true });
  }

  get({ page = 1, search, sort, knowledgeBaseId } = {}) {
    const params = { page };
    if (search) params.search = search;
    if (sort) params.sort = sort;
    if (knowledgeBaseId) params.knowledge_base_id = knowledgeBaseId;
    return axios.get(this.url, { params });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data = {}) {
    return axios.post(this.url, {
      faq: data,
    });
  }

  update(id, data = {}) {
    return axios.patch(`${this.url}/${id}`, {
      faq: data,
    });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  publish(id) {
    return axios.post(`${this.url}/${id}/publish`);
  }

  unpublish(id) {
    return axios.post(`${this.url}/${id}/unpublish`);
  }

  retry(id) {
    return axios.post(`${this.url}/${id}/retry`);
  }

  // 批量操作
  bulkPublish(ids) {
    return axios.post(`${this.url}/bulk_publish`, { ids });
  }

  bulkUnpublish(ids) {
    return axios.post(`${this.url}/bulk_unpublish`, { ids });
  }

  bulkRetry(ids) {
    return axios.post(`${this.url}/bulk_retry`, { ids });
  }

  bulkDestroy(ids) {
    return axios.post(`${this.url}/bulk_destroy`, { ids });
  }

  search(query, { knowledgeBaseId, limit = 5 } = {}) {
    return axios.post(`${this.url}/search`, {
      query,
      knowledge_base_id: knowledgeBaseId,
      limit,
    });
  }

  // eslint-disable-next-line default-param-last
  filter(page = 1, sortAttr = 'created_at', queryPayload, search) {
    let requestURL = `${this.url}/filter?page=${page}`;
    if (sortAttr) {
      requestURL += `&sort=${sortAttr}`;
    }
    if (search) {
      requestURL += `&search=${encodeURIComponent(search)}`;
    }
    if (queryPayload?.knowledge_base_id) {
      requestURL += `&knowledge_base_id=${queryPayload.knowledge_base_id}`;
    }
    return axios.post(requestURL, queryPayload);
  }

  // 导入 Excel 文件
  importExcel(formData) {
    return axios.post(`${this.url}/import_excel`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }
}

export default new PilotFaqs();
